export default{
    Title: 'Bảng tổng hợp chứng từ cùng loại',
    Detail: {
        RefNo: 'Số',
        RefDate: 'Ngày',
        Description: 'Diễn giải',
        ChooseVoucherPosted: 'Chọn chứng từ'
    }
}